/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import commands from './commands';
import MetricsContext from './MetricsContext';
import WidgetLabHeader from './WidgetLabHeader';
import { useContext, createRef, Fragment, useState, useEffect } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import WidgetLabItem from './WidgetLabItem';
import ShadowContainer from './ShadowContainer';

export default (): Element<string> => {
  const ctx = useContext(MetricsContext);
  const { placeMetrics, placeMetricsOrder } = ctx.state;
  const containerRef = createRef();
  const headerRef = createRef();

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const { source, destination } = result;
    commands(ctx).reorder(source.index, destination.index);
  };

  const [scrollHeight, setScrollHeight] = useState(0);
  useEffect(() => {
    if (containerRef.current && headerRef.current) {
      const contHeight = containerRef.current.offsetHeight;
      const headerHeight = headerRef.current.offsetHeight;
      setScrollHeight(contHeight - headerHeight - 145);
    }
  }, [containerRef, headerRef]);

  const orderedMetrics = placeMetricsOrder
    ? placeMetricsOrder.map((id) =>
        placeMetrics.find((v) => String(v.id) === String(id))
      )
    : [];

  return (
    <div css={css('height: 100%;')} ref={containerRef}>
      <WidgetLabHeader ref={headerRef} />
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <ShadowContainer
              {...provided.droppableProps}
              ref={provided.innerRef}
              scrollHeight={scrollHeight}
            >
              <Fragment>
                {orderedMetrics.map((v, i) => (
                  <WidgetLabItem key={i} index={i} {...v} />
                ))}
                {provided.placeholder}
              </Fragment>
            </ShadowContainer>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};
